var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow"},[_c('Flowy',{attrs:{"nodes":_vm.localNodes,"beforeMove":_vm.beforeMove,"beforeAdd":_vm.beforeAdd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }